/**
 * Created by Qingger Corp.
 * User: jsspf
 * Date: 2017/11/21
 * Time: 18:32
 */

/**
 * Cache Key默认设置
 */
export class CacheKeyType {
  // 用来保存用户信息
  static CACHE_FOR_EMPINFO = 'CACHE_FOR_EMPINFO';
  // 用户TOKEN
  static CACHE_FOR_PORTAL_TOKEN = 'ADMIN_USER_TOKEN';
  // CORPID
  static CACHE_FOR_CORPID = 'ADMIN_CORP_ID';

  static CACHE_FOR_PLATID = 'ADMIN_PALT_ID';

  static CACHE_FOR_ACT_ID = 'ACT_ID';
}
